import { SvgIcon } from '@material-ui/core'

export const UserIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26" style={{ fill: 'none' }} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3337 24.5C23.3337 22.8718 23.3337 22.0578 23.1327 21.3953C22.6803 19.9039 21.5131 18.7367 20.0217 18.2843C19.3592 18.0833 18.5452 18.0833 16.917 18.0833H11.0837C9.4555 18.0833 8.64142 18.0833 7.97899 18.2843C6.48752 18.7367 5.32037 19.9039 4.86794 21.3953C4.66699 22.0578 4.66699 22.8718 4.66699 24.5M19.2503 8.75C19.2503 11.6495 16.8998 14 14.0003 14C11.1008 14 8.75033 11.6495 8.75033 8.75C8.75033 5.85051 11.1008 3.5 14.0003 3.5C16.8998 3.5 19.2503 5.85051 19.2503 8.75Z"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
